/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMergeState } from 'irmlib/hooks'
import styled from 'styled-components'
// import { FlexByRow, FloatRight, XDivider, HalfScreen, makeStyles } from 'irmlib/styles'
// import { Dialog, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
// import { Label, ToolTip, OutlinedButton } from 'irmlib/components/Controls'
// import { Edit } from 'irmlib/icons'
import Table from '../../Controls/Table'
// import * as constants from 'irmlib/common/constants'
import { useTranslation } from 'react-i18next'
import ImageContainer from '../SmartCatalog/MultiImageContainer'
import { Visibility } from '@material-ui/icons'
// import { errorToast } from '../../../common/functions'

// const ROW_SELECTED = 'rowSelected'
// const NOT_SELECTED = 'notSelected'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 0px;
`
const TableContainer = styled(BottomPaddedDiv)`
`
// const useStyles = makeStyles({
//   disabledState: {
//     pointerEvents: 'none',
//     opacity: '0.4'
//   },
//   editIcon: {
//     cursor: 'pointer'
//   }
// })

// const CenteringFlexRow = styled(FlexByRow)`
//   align-items: center;
// `
const initialState = {
  selectedImage: null
}

const ImageTemplateFormat = (props) => {
  const { t } = useTranslation()
  // eslint-disable-next-line
  const [, setState, getState] = useMergeState(initialState)
  const [selectedImage, setSelectedImage] = React.useState(null)
  // const classes = useStyles()
  const [selectedImageIndex, setSelectedImageIndex] = useState(null)

  

  const handleOpen = (index) => {
    setSelectedImageIndex(index)
  }

  //   const handleClose = () => {
  //     setState({ selectedImage: null })
  //   }
  
  const handleClose = () => {
    setSelectedImageIndex(null)
  }

  const MultiImageContainer = () => (
    // getState().boxes.map((box, boxIndex) => (
    <div>
      {selectedImageIndex !== null && (
      <ImageContainer
        images={selectedImage}
        selectedImageIndex={selectedImageIndex}
        handleClose={handleClose}
          />
      )}
    </div>
    // ))
  )

  const columns = [
    {
      title: 'Seq.',
      field: 'sequence',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    // {
    //   title: 'ID',
    //   field: 'id',
    //   headerAlign: 'center',
    //   sortable: false,
    //   width: '30%'
    // },
    {
      title: t('tableColumns.barcode'),
      field: 'barCode',
      headerAlign: 'center',
      sortable: false,
      width: '40%'
    },
    {
      title: t('tableColumns.status'),
      field: 'status',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.idpStatus'),
      field: 'idpStatus',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.exceptionMsg'),
      field: 'exception',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('reports.employeeLevel.employee'),
      field: 'userName',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.createdTime'),
      field: 'createdTS',
      headerAlign: 'center',
      sortable: false,
      width: '30%'
    },
    {
      title: t('tableColumns.images'),
      field: 'images',
      headerAlign: 'center',
      sortable: false,
      width: '30%',
      render: (rowData) => {
        if (rowData?.images && rowData?.images.length !== 0) {
          return <Visibility
          style={{ cursor: 'pointer', fontSize: 32 }}
            onClick={() => {
              handleOpen(0)
              setSelectedImage(rowData?.images)
            }
              }/>
        } else {
          return null
        }
      }
    },
  ]

  if (props?.wmscode === 'SKP' || props.assetType.includes('Box')) {
    const indexOfwmsStatusColumn = columns.findIndex(column => column.field === 'barCode')
    if (indexOfwmsStatusColumn !== -1) {
      columns.splice(indexOfwmsStatusColumn, 1)
    }
  }
  //   const ImageContainer = () => {
  //     return (
  //       <Dialog open={!!getState().selectedImage} onClose={handleClose}>
  //         <DialogContent>
  //           <DialogContentText>
  //             <img 
  //               src={getState().selectedImage} 
  //               alt="Box Image" 
  //               style={{ width: '100%', height: 'auto', maxWidth: '400px', maxHeight: '400px' }} 
  //             />
  //           </DialogContentText>
  //         </DialogContent>
  //         <DialogActions>
  //           <Button onClick={handleClose} color="primary">
  //             Close
  //           </Button>
  //         </DialogActions>
  //       </Dialog>
  //     )
  //   }
  

  const getPageData = async (page, pageSize) => {
    const dataRows = await props.getPageData(page, pageSize)
    return Promise.resolve(dataRows)
  }

  const onSelectionChange = (rows, row, val) => {
    if (rows.length > 1) {
      const requestList = props.tableRef.current.dataManager.data
      let index = 0
      for (const selectedRow of requestList) {
        if (row.id !== selectedRow.id) {
          if (requestList[index].tableData.checked) {
            requestList[index].tableData.checked = false
          }
        }
        ++index
      }
      props.tableRef.current.setState(requestList)
    }

    if (props.selectedRecord !== false) {
      if (row.tableData.checked) {
        props.selectedRecord(row.id)
      } else {
        props.selectedRecord(false)
      }
    }
  }

  return (
    <>
      <TableContainer>
        <Table
          title={props.title}
          tableRef={props.tableRef}
          totalRecords={200}
          columns={columns}
          getPageData={getPageData}
          rowsPerPageOptions={[30]}
          exportButton={false}
          paging={false}
          draggable={false}
          sorting={false}
          onSelectionChange={onSelectionChange}
          selection={true}
          showSelectAllCheckbox={false}
          reportFor={'multiRequestSelection'}
          />
      </TableContainer>
      <MultiImageContainer/>
    </>
  )
}

ImageTemplateFormat.propTypes = {
  tableRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  wmscode: PropTypes.string,
  assetType: PropTypes.string,
  // jobDetails: PropTypes.string,
  getPageData: PropTypes.func,
  selectedRecord: PropTypes.func,
//   fromMultiReqs: PropTypes.bool
}

export default ImageTemplateFormat